import { useEffect } from "react";

/**
 * To listen to changes in localStorage for a specific key
 * @param key string
 * @param callback
 */
const useLocalStorageChange = (
  key: string,
  callback: (value: string | null) => void
) => {
  useEffect(() => {
    const handleStorageChange = () => {
      const updatedValue = localStorage.getItem(key);
      callback(updatedValue);
    };

    // Add custom event listener for localStorage changes
    window.addEventListener("localStorageChange", handleStorageChange);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("localStorageChange", handleStorageChange);
    };
  }, [key, callback]);
};

export default useLocalStorageChange;
